<bitf-dnd-file (dropFiles)="onFileDropped($event)"
  *ngIf="showDndArea"
  class="d-none d-md-block mt-3">
  <div class="d-flex flex-column align-items-center justify-content-center h-100 pt-3">
    <div class="text-center mat-body-medium">
      {{ 'BITF.FILE_UPLOADER.DROP_FILES_HERE_OR_SELECT' | translate }}
    </div>

    <ng-container *ngTemplateOutlet="selectFileTemplate"></ng-container>

  </div>
</bitf-dnd-file>

<div class="d-block d-md-none w-100 p-1">
  <ng-container *ngTemplateOutlet="selectFileTemplate"></ng-container>
</div>

<div *ngIf="files.length && showFileList"
  class="mt-3">
  <div class="d-flex align-items-center justify-content-between">
    <h5>
      {{'BITF.FILE_UPLOADER.SELECTED_FILES' | translate}}
    </h5>
    <div class="d-flex align-items-center">
      <button mat-button
        *ngIf="!uploadOnFilesDropped"
        (click)="removeAllFiles()"
        [disabled]="isUploading">
        {{ 'BITF.FILE_UPLOADER.REMOVE_ALL_FILES' | translate }}
      </button>
      <button mat-flat-button
        *ngIf="!fileUploaderConfig.hideUploadButton && !uploadOnFilesDropped"
        [disabled]="isUploading"
        (click)="upload()"
        class="ml-2">
        {{ 'BITF.FILE_UPLOADER.UPLOAD' | translate }}
      </button>
    </div>
  </div>

  <mat-list>
    <mat-list-item *ngFor="let file of files; let index = index;"
      class="border-bottom px-0">
      <div class="row m-0 w-100">
        <div class="col-18 pl-0 pr-2 mat-body-small text-truncate">
          {{ file.fileObject.name }} <br> ({{file.fileObject.size | bitfBytes}})
        </div>

        <div class="col-6 pl-2 pr-0">
          <div class="w-100 h-100 d-flex align-items-center justify-content-end">
            <mat-spinner color="primary"
              class="mx-2"
              [diameter]="22"
              *ngIf="file.isUploading"></mat-spinner>

            <button mat-icon-button
              *ngIf="file.validationErrors.length"
              color="warn"
              class="ml-2"
              [matTooltip]="file.validationErrorsTooltip">
              <mat-icon class="warning">warning</mat-icon>
            </button>

            <button mat-icon-button
              class="ml-2 cursor-pointer"
              *ngIf="!file.isUploading"
              (click)="removeFile(index)">
              <mat-icon>delete</mat-icon>
            </button>

            <mat-icon *ngIf="file.hasUploadErrors">error</mat-icon>
          </div>
        </div>
      </div>
    </mat-list-item>
  </mat-list>
</div>

<ng-template #selectFileTemplate>
  <div class="d-flex justify-content-center my-3">
    <button mat-flat-button
      (click)="selectFile.click()"> {{ 'BITF.FILE_UPLOADER.SELECT_FILE' | translate | uppercase }}
    </button>
    <input class="d-none"
      type="file"
      #selectFile
      id="selectFile"
      [attr.multiple]="(maxNumberOfFiles > 1) ? '' : null"
      (change)="onFileDropped($event)" />
  </div>

  <div *ngIf="uploadFolder">
    <button mat-stroked-button
      (click)="selectDirectory.click()"> {{ 'BITF.FILE_UPLOADER.SELECT_FOLDER' | translate | uppercase }}
    </button>
    <input class="d-none"
      type="file"
      #selectDirectory
      webkitdirectory
      mozdirectory
      (change)="onFileDropped($event)" />
  </div>
</ng-template>